export const WEEK = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'viernes', 'Sabado'];
